export default __webpack_public_path__ + "static/media/Remolquede SúperLujo2.05606f60.png";